export class IntervaloRange {
  de: number;
  ate: number;
  cor: string;
  tipo: string;
}
